import { createFileRoute } from '@tanstack/react-router';
import { HeaderDashboard } from '@/components/shared/header-dashboard';
import { WalletList } from '@/features/consumer/wallet-list';

export const Route = createFileRoute('/(consumer)/_authenticated/my-wallet/')({
  component: MyWalletPage,
});

function MyWalletPage() {
  return (
    <div>
      <HeaderDashboard>
        <HeaderDashboard.Title>My Wallet</HeaderDashboard.Title>
        {/* <HeaderDashboard.Action>
          <Button
            size="sm"
            className="bg-black dark:bg-gray-200"
            onClick={() => navigate({ to: '/my-wallet/add-payment-card' })}
          >
            Add Payment
          </Button>
        </HeaderDashboard.Action> */}
      </HeaderDashboard>
      <div className="flex flex-col gap-4">
        <WalletList />
      </div>
    </div>
  );
}
